import { ReduxState } from '../utils/typeHelpers'

export const selectFlyoutState = (state: ReduxState) => state.flyout
